<template>
  <div class="w-full sm:w-2/3 md:w-2/3 lg:w-1/2 mx-auto mb-3 border-gray-400 border-none">
    <ticket-header :exam="exam" />
    <div class="rounded-b-lg px-3 pt-3 pb-1 w-full bg-gray-100 text-gray-900">
      <purchase-detail
        :id="userProductDetail.id"
        :user="userProductDetail.user"
        :email="userProductDetail.email"
        :name="userProductDetail.name"
        :ticket-id="userProductDetail.ticket_id"
        :city="userProductDetail.city"
        :major="userProductDetail.major" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      validator: (val) => true,
      default: null,
    },
    exam: {
      required: true,
      type: Object,
    }
  },
  computed: {
    userProductDetail() {
      return this.$store.getters.giftProductById(this.id);
    },
  },
  mounted() {
    this.$nextTick(function () {
      // this.$store.commit('setCurrentPath', '');
    })
  },
  methods: {
  },
}
</script>
